module.exports = "/_next/static/images/c7a9f49309e1b9ab42ebb1253b67525c-website-thumb.jpg";